/**
 * components.js
 *
 * Import the JS for your components here.
 *
 */
import './BackToTop/BackToTop';
import './Modal/Modal';
import './IframeComponent/IframeComponent';
import './OptimizelyForms/Form';
import CopyPageUrl from './SocialShare/SocialShare';
import Slider from './Slider/Slider';
import CookieConsent from './CookieConsent/CookieConsent';
import ChartComponent from './Chart/Chart';
import ComponentInit from '../js/utils/ComponentInit';

// Format:
// data-component-name: ComponentFunction
// we shall order these in page load critical first
const componentList = { Slider, CopyPageUrl, CookieConsent, ChartComponent };

// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
export default ComponentInit(componentList);
